export default __webpack_public_path__ + "static/media/wave-logo.3a5722a1.svg";